import { BMPrimitives, useBMTheme } from '../../../theme';
export default function useCardStyle(elevation, layout) {
    const { BMComponents, BMElevation } = useBMTheme();
    let style = { backgroundColor: BMComponents.BMStyleCardBgcolor };
    switch (layout) {
        case 'SPACIOUS':
            style = {
                ...style,
                padding: BMPrimitives.BMSize.xl,
                borderRadius: BMComponents.BMStyleCardRadiusSpacious,
            };
            break;
        default:
        case 'COMPACT':
            style = {
                ...style,
                padding: BMPrimitives.BMSize.md,
                borderRadius: BMComponents.BMStyleCardRadiusCompact,
            };
            break;
    }
    switch (elevation) {
        case 'BOX':
            style = {
                ...style,
                borderWidth: BMPrimitives.BMBorder.width.thick,
                ...BMElevation.elevation1,
            };
            break;
        case 'FLOAT':
            style = {
                ...style,
                borderColor: BMComponents.BMStyleCardBordercolor,
                borderWidth: BMPrimitives.BMBorder.width.thick,
                overflow: 'hidden',
                ...BMElevation.elevation2,
            };
            break;
        default:
        case 'REST':
            style = {
                ...style,
            };
            break;
    }
    return style;
}
